import { useState } from "react";

const scenarioOptions = [
  {
    id: "individual",
    title: "我是个体户/小商户，没有进出口权",
    note: "有货想出，但卡在资质和报关这一步",
    icon: "ri-store-2-line",
    result: "推荐 1039 全托管 · 无需自营进出口权",
  },
  {
    id: "invoiceless",
    title: "我的货没有进项发票，难退税",
    note: "小商品、多品种、小批量，无票采购",
    icon: "ri-file-unknow-line",
    result: "推荐 1039 市场采购 · 免征不退",
  },
  {
    id: "forex",
    title: "我需要阳光收汇、结汇到账",
    note: "货款要合规回来，还能留痕归档",
    icon: "ri-exchange-funds-line",
    result: "推荐收汇结汇服务 · 阳光合规",
  },
  {
    id: "crossborder",
    title: "我做跨境电商/有平台店铺",
    note: "平台直邮或海外仓，需要合规出口通道",
    icon: "ri-global-line",
    result: "推荐 9610/9710 方案 · 按次灵活",
  },
];

export default function PlanSelector() {
  const [selected, setSelected] = useState<string>("individual");

  const current = scenarioOptions.find((o) => o.id === selected)!;

  return (
    <section id="plans" className="py-16 md:py-28 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-[28px] md:text-[38px] font-heading font-bold text-foreground-800 mb-3 tracking-tight">
            30秒找到适合你的服务
          </h2>
          <p className="text-foreground-600 text-[15px] md:text-[16px]">
            选一个最像你的情况，系统自动推荐最优方案
          </p>
        </div>

        <div className="space-y-6 md:space-y-8">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8">
            <h3 className="text-[17px] md:text-lg font-semibold text-foreground-800 mb-5 md:mb-6">
              Step 1：你现在最想解决什么?
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              {scenarioOptions.map((o) => {
                const active = selected === o.id;
                return (
                  <button
                    key={o.id}
                    onClick={() => setSelected(o.id)}
                    className={`p-5 md:p-6 rounded-xl text-left transition-all cursor-pointer border-2 flex items-start gap-4 ${
                      active
                        ? "border-primary-500 bg-primary-50"
                        : "bg-background-50 border-background-200 hover:border-primary-300"
                    }`}
                  >
                    <span
                      className={`w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0 ${
                        active ? "bg-primary-500" : "bg-background-100"
                      }`}
                    >
                      <i
                        className={`text-xl ${
                          active ? "text-background-50" : "text-primary-600"
                        } ${o.icon}`}
                      />
                    </span>
                    <span>
                      <span className="block font-semibold text-foreground-800 mb-1">
                        {o.title}
                      </span>
                      <span className="block text-sm text-foreground-500">
                        {o.note}
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-4 bg-background-50 border border-primary-100 rounded-2xl p-5 md:p-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-magic-line text-background-50 text-xl" />
              </span>
              <div className="flex-1">
                <p className="text-sm text-foreground-500 mb-0.5">为你推荐</p>
                <p className="text-[16px] md:text-[17px] font-bold text-primary-700">
                  {current.result}
                </p>
              </div>
            </div>
            <a
              href="#pricing"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-1 px-5 py-2.5 text-sm text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap"
            >
              查看价格 <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}